import { cn } from '@/lib/cn';
import type { ComponentProps } from 'react';

type FieldsetProps = ComponentProps<'fieldset'>;

function Fieldset({ className, ref, ...props }: FieldsetProps) {
  return (
    <fieldset
      ref={ref}
      className={cn(
        'col-span-full grid gap-6 rounded-lg border bg-surface p-4',
        className
      )}
      {...props}
    />
  );
}

export { Fieldset };
